<template>
  <b-card>
    <FormBuilder
      label="Kategori"
      create
      :fields="fields"
      :loading-submit="$store.state.categoryV2.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return { fields }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('categoryV2/create', data)
        .then(() => {
          if (typeof callback === 'function') callback()
          this.$router.push({ name: 'categories-v2' })
        })
        .catch(err => callback(err))
    },
  },
}
</script>
